import { render, staticRenderFns } from "./BaseService.vue?vue&type=template&id=67b210af&"
import script from "./BaseService.vue?vue&type=script&lang=js&"
export * from "./BaseService.vue?vue&type=script&lang=js&"
import style0 from "./BaseService.vue?vue&type=style&index=0&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports